import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { ListReminderUseCase } from './ListReminderUseCase';
import { SetReminderUseCase } from './SetReminderUseCase';
import { UnSetReminderUseCase } from './UnSetReminderUseCase';

export const initializeReminderUseCases = (container: Container) => {
    container.register(DI.USECASES.IListReminderUseCase, {
        useClass: ListReminderUseCase,
    });
    container.register(DI.USECASES.ISetReminderUseCase, {
        useClass: SetReminderUseCase,
    });
    container.register(DI.USECASES.IUnSetReminderUseCase, {
        useClass: UnSetReminderUseCase,
    });
};
